import { RoutedModal } from "../../../../components/common";
import secondaryComponents from "../../../../components/secondaryComponents";
import globalStyles from "../../../../assets/styles/base/globalPage.module.scss";
import useReconciliationReview from "../../../appPages/Inventory/Reconciliation/ReconciliationReview/useReconciliationReview";

export const SMReconciliationReview = () => {
  const {
    isLoading,
    isFetchingNextPage,
    hasNextPage,
    fetchNextPage,
    products,
    reconciliedData,
    storeDetails,
    setReconciliedData,
  } = useReconciliationReview({});

  return (
    <RoutedModal
      isActive={true}
      hasPrevNavigation={true}
      headerTitle={`Reconciliation Review - ${storeDetails?.name}`}
      headerDescription="View reconciliation details"
      rightHeaderSide={null}
    >
      <section className={`${globalStyles.cardWithBorder} overflow-hidden p-0`}>
        <div>
          <secondaryComponents.LoaderHelper
            classNames="my-5"
            isLoading={isLoading}
          >
            <secondaryComponents.ReconcileStockEditView
              store_currency={storeDetails?.currency_code}
              products={products}
              setReconciliedData={setReconciliedData}
              reconciliedData={reconciliedData}
              discrepancyReasons={[]}
              isReviewMode={true}
              hasNextPage={hasNextPage}
              isFetchingNextPage={isFetchingNextPage}
              fetchNextPage={fetchNextPage}
            />
          </secondaryComponents.LoaderHelper>

          <secondaryComponents.LoaderHelper
            classNames="mt-4"
            isLoading={isFetchingNextPage && !isLoading}
          ></secondaryComponents.LoaderHelper>
        </div>
      </section>
    </RoutedModal>
  );
};
